import { ioParameter } from "./ioparameters.model";

export class customFunction{
  functionName: string;
  method: string;
  functionUrl: string;
  api: string;
  inputParameters: ioParameter[];
  outputParameters: ioParameter[];
  keyValue: string;  
  refinaryName : string;


  constructor() {
    this.functionName = '';
    this.method = '';
    this.functionUrl = '';
    this.api = '';
    this.inputParameters = [];
    this.outputParameters = [];
    this.keyValue = '';  
    this.refinaryName = '';
  }
}
